import { toast } from "react-toastify";

import API from "../../api";
import {
  formatCrmPetRecoveryAttempts,
  formatCrmPetRecoveryKpis,
  formatCrmPetUsage,
} from "../../formatResponses/crmPetDiagnosis";
import { useCrmPetDiagnosis } from "../../../store/crmPetDiagnosis/useCrmPetDiagnosis";

const KPI_SECTION_MAP = {
  overview: {
    default: "overviewKpis",
    contacted: "overviewContactedKpis",
  },
  results: {
    default: "resultsKpis",
    contacted: "resultsContactedKpis",
  },
};

class CrmPetDiagnosisModelClass {
  actions = useCrmPetDiagnosis.getState().actions;

  async findUsage(storeId, filters) {
    return this.requestSection(
      "usage",
      async () => {
        const { data } = await API.get(`crm-pet/usage/stores/${storeId}`, {
          params: {
            from: filters.from,
            to: filters.to,
            page: 1,
            perPage: 20,
          },
        });
        const usage = formatCrmPetUsage(data);
        this.actions.setUsage(usage);
        return usage;
      },
      "Não foi possível carregar a utilização do CRM Pet.",
    );
  }

  async findRecoveryKpis(scope, filters, contacted = false) {
    const section = KPI_SECTION_MAP[scope]?.[contacted ? "contacted" : "default"];

    return this.requestSection(
      section,
      async () => {
        const params = this.recoveryParams(filters, { includeMinDays: true });
        if (contacted) params.contacted = true;

        const { data } = await API.get("crm-pet/recovery/kpis", { params });
        const kpis = formatCrmPetRecoveryKpis(data);

        this.actions.setKpis(section, kpis);
        return kpis;
      },
      contacted
        ? "Não foi possível carregar os clientes contatados."
        : "Não foi possível carregar os indicadores de recuperação.",
    );
  }

  async findRecoveryAttempts(filters, page = 0, perPage = 20) {
    return this.requestSection(
      "attempts",
      async () => {
        const { data } = await API.get("crm-pet/recovery/attempts", {
          params: {
            ...this.recoveryParams(filters, {
              includeMinDays: true,
              includeStatus: true,
              includeContacted: true,
            }),
            page: page + 1,
            perPage,
          },
        });
        const formatted = formatCrmPetRecoveryAttempts(data, page, perPage);
        this.actions.setAttempts(formatted.results, formatted.pagination);
        return formatted;
      },
      "Não foi possível carregar os clientes contatados.",
    );
  }

  recoveryParams(
    filters,
    { includeMinDays = false, includeStatus = false, includeContacted = false } = {},
  ) {
    const params = {
      from: filters.from,
      to: filters.to,
    };

    if (includeMinDays) {
      params.minDays = Number(filters.minDays) || 30;
    }

    if (includeStatus && filters.status && filters.status !== "all") {
      params.status = filters.status;
    }

    if (includeContacted && filters.contacted && filters.contacted !== "all") {
      params.contacted = filters.contacted === "true";
    }

    return params;
  }

  async requestSection(section, request, fallbackMessage) {
    this.actions.setLoading(section, true);
    this.actions.setError(section, null);

    try {
      return await request();
    } catch (error) {
      const message =
        error?.response?.data?.friendly_message || error?.message || fallbackMessage;
      this.actions.setLoading(section, false);
      this.actions.setError(section, message);
      toast.error(message, { theme: "colored" });
      return null;
    }
  }
}

let model = null;

export function CrmPetDiagnosisModel() {
  if (!model) model = new CrmPetDiagnosisModelClass();
  return model;
}
